import { Heading } from '../Typography';
import { Card } from './Card';
import { IconHeadingWrapper, StyledIconCard } from './styles';

interface IconCardProps extends React.ComponentPropsWithoutRef<typeof Card> {
    heading: string;
    icon: React.ReactNode;
}

export const IconCard = ({ heading, icon, children, ...otherProps }: IconCardProps) => {
    return (
        <StyledIconCard {...otherProps} aria-labelledby={heading}>
            <IconHeadingWrapper>
                <Heading level={3}>{heading}</Heading>
                {icon}
            </IconHeadingWrapper>
            {children}
        </StyledIconCard>
    );
};
